"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../../");
const react_query_1 = require("react-query");
/**
 *  Dice si el paciente tiene o no una subscription
 */
function useHasSubscription(firestore, uid, queryOptions) {
    const hasSubscription = (0, react_query_1.useQuery)(__1.FirestoreKeys.WithoutCategory({
        name: "hasSuscription",
        path: `user/${uid}/subscriptions`
    }, [uid]), () => {
        return (0, __1.isActiveSubscriptor)(firestore, uid);
    }, queryOptions);
    return hasSubscription;
}
exports.default = useHasSubscription;
